export default "<router-outlet></router-outlet>\r\n\r\n<app-toastr></app-toastr>"